import Dropdown from 'flarum/common/components/Dropdown';
import Button from 'flarum/common/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
import Stream from 'flarum/common/utils/Stream';
import app from 'flarum/forum/app';

export default class TicketLanguageFilter extends Dropdown {
  static initAttrs(attrs) {
    attrs.icon = 'fas fa-language';
    attrs.label = 'Language';

    attrs.buttonClassName = 'Button';
    attrs.menuClassName = 'Dropdown-menu--right';
    attrs.accessibleToggleLabel = 'Language';

    super.initAttrs(attrs);
  }

  oninit(vnode) {
    this.search = Stream('');

    super.oninit(vnode);
  }

  view(vnode) {
    return super.view({ ...vnode, children: this.items().toArray() });
  }

  items() {
    const items = new ItemList();

    const language = this.attrs.language;

    items.add(
      'nofilter',
      <Button className={'Button'} onclick={() => this.attrs.setLanguage(null)} icon={language.length === 0 ? 'fa fa-check' : 'fa'}>
        {app.translator.trans('v17development-flarum-support.forum.tickets.overview.filter.language.any')}
      </Button>
    );

    app.store.all('supportTicketLanguages').map((ticketLanguage) => {
      // New tickets
      items.add(
        ticketLanguage.code(),
        <Button
          className={'Button'}
          onclick={() => this.attrs.setLanguage(ticketLanguage.id())}
          icon={language.indexOf(ticketLanguage.id()) >= 0 ? 'fa fa-check' : 'fa'}
        >
          {ticketLanguage.name()}
        </Button>
      );
    });

    return items;
  }
}
